/* eslint-disable @typescript-eslint/naming-convention */
import React, { useMemo, useRef } from 'react';
import clsx from 'classnames';
import { Tooltip } from '@progress/kendo-react-tooltip';
import { GenericEventIcon } from '@features/Calendar/constants';
import useEventContext from '@features/MapScheduler/Scheduler/scheduler-only-hooks/use-event-context';
import useScheduleAndDispatchContext from '@features/MapScheduler/Hooks/useScheduleAndDispatchContext';
import useSchedulerContext from '@features/MapScheduler/Hooks/useSchedulerContext';
function EventGeneric() {
    const { event } = useEventContext();
    const { clusterInfo, metadata } = useEventContext();
    const { openEditGenericEventModal } = useScheduleAndDispatchContext();
    const dynamicClass = useMemo(() => {
        return clsx('event__item', {
            '--overflow': metadata.overflowPrevDay || metadata.overflowNextDay,
            '--prev': metadata.overflowPrevDay,
            '--next': metadata.overflowNextDay
        });
    }, [metadata]);
    const dynamicStyles = useMemo(() => {
        return {
            left: `${metadata.startTimeAsPercentage}%`,
            width: `${metadata.endTimeAsPercentage - metadata.startTimeAsPercentage}%`,
            height: `${(100 / clusterInfo.subdivision) * clusterInfo.span}%`,
            top: `calc((${100 / clusterInfo.subdivision}% ) * ${clusterInfo.offset})`,
            borderTop: clusterInfo.offset === 0 ? 'unset' : 'transparent'
        };
    }, [clusterInfo, metadata]);
    const typeIcon = useMemo(() => {
        var _a;
        return React.createElement("i", { className: (_a = GenericEventIcon[event.eventType]) !== null && _a !== void 0 ? _a : 'fa-light fa-square-question' });
    }, [event.eventType]);
    return (React.createElement("div", { className: dynamicClass, style: dynamicStyles, onClick: () => openEditGenericEventModal(event.id) },
        React.createElement("div", { className: "event__card--generic-event" },
            React.createElement(OverflowIndicators, null),
            React.createElement(Tooltip, { anchorElement: "target", position: "top" },
                React.createElement("div", { className: "event__crux" },
                    React.createElement("span", { className: "event__type" }, typeIcon),
                    React.createElement("span", { className: "event__time" }, event.start.format('hh:mm a')),
                    React.createElement("span", { className: "event__bullet_wrapper" },
                        React.createElement("span", { className: "event__bullet" })),
                    React.createElement("span", { className: "event__title" }, event.title))))));
}
function OverflowIndicators() {
    const { metadata } = useEventContext();
    const { incrementCurrentDate, decrementCurrentDate } = useSchedulerContext();
    const left = useRef(null);
    const right = useRef(null);
    const HandleClick = (e, isLeftIndicator) => {
        e.stopPropagation();
        if (isLeftIndicator)
            decrementCurrentDate();
        else
            incrementCurrentDate();
    };
    const leftIndicator = !metadata.overflowPrevDay ? null : (React.createElement("div", { ref: left, className: "event__nav--left" },
        React.createElement("button", { className: "qmb-control--icon", onClick: (e) => HandleClick(e, true) },
            React.createElement("i", { className: "fa-light fa-angle-left" }))));
    const rightIndicator = !metadata.overflowNextDay ? null : (React.createElement("div", { ref: right, className: "event__nav--right" },
        React.createElement("button", { className: "qmb-control--icon", onClick: (e) => HandleClick(e, false) },
            React.createElement("i", { className: "fa-light fa-angle-right" }))));
    return (React.createElement(React.Fragment, null,
        leftIndicator,
        rightIndicator));
}
export default EventGeneric;
